import { CloseIcon } from '@chakra-ui/icons';
import { Button, HStack, Heading, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Stack, Text } from '@chakra-ui/react';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import React, { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { MyNetworkContext } from 'v4/components/network/context';
import { blockConnection } from 'v4/store/actions/connection.actions';

const UserBlockPopup = ({onClose, isBlockUserModal, selectedChat, fetchRoomList, socketRef, setRoomId}) => {
  const { allDegreeConnectionsArr } = useSelector((state) => state.connection);
  const { t } = useTranslator();
  const warningText = `You and ${selectedChat?.user_details?.display_name} won’t be friends on myBridge. ${selectedChat?.user_details?.display_name}’s messages and calls will also be blocked.`;
  
  const {blockUser,blocked } = useContext(MyNetworkContext);
  
  const matchedConnection = allDegreeConnectionsArr?.[0]?.find(
    (connection) => connection?.id === selectedChat?.user_details?.user_id
  );
    
  // Get the ID from the matched item (assuming it has an `id` property)
  const connectionId = matchedConnection?.id;

  const handleBlockUser = async () => {
    try {
      // const response = await blockUser(matchedConnection); 
      const response = await blockUser(matchedConnection || { id: selectedChat?.user_details?.user_id || selectedChat?.user_details?.id }); 
      if (response?.state_code >= 400) {
        // console.log("Blocking user failed", response);
    
      } else {
        // First clear the chat selection
        // setRoomId(null);
        onClose(); 

        // Then emit socket event to notify about user block
        // socketRef?.current?.emit('user_blocked', {
        //   blocked_user_id: selectedChat?.user_details?.user_id,
        //   room_id: selectedChat?.room_id
        // });
        
        // Finally fetch room list to update UI
        await fetchRoomList();
      }
    } catch (error) {
      console.error("Error in blocking user:", error);
    }
  };

  return (
    <>
        <Modal isOpen={isBlockUserModal} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent 
        backgroundColor="#FFFFFF"
        padding="5px 5px 0px 5px"
        maxWidth="436px"
        borderRadius="16px"
        >
          <ModalHeader>
            <HStack alignItems='center' justifyContent='space-between'>
                <Heading fontSize="15px" fontFamily="Inter" lineHeight="18px" fontWeight={600} color="#5B5B5B">
                {t('myMessages.blockOnMyBridge') || "Block on myBridge?"}
                </Heading>
        <CloseIcon cursor="pointer" width="10px" height="10px" color="#5B5B5B" fontWeight={600}  onClick={()=>onClose()}/>
            </HStack>
          </ModalHeader>
          <ModalBody>
            <Text maxWidth="388px" w="100%">
            {warningText}
              <Text display="inline" fontWeight="bold">
                {/* "{getFullFileName(selectedFile)}" */}
              </Text>
              ?
            </Text>
          </ModalBody>
          <ModalFooter>
            <HStack>
              <Button 
              backgroundColor="transparent"
              border= "1px solid #D9D9D9"
              borderRadius="76px"
              p="9px 18px"
              fontSize="12px"
              fontWeight={500}
              lineHeight="14.4px"
              color="#3D5A80"
              _hover={{
                backgroundColor:"transparent"
              }}
              onClick={()=>{
              onClose();
              }}
              >
                {t('buttons.cancel') || "Cancel"}
              </Button>
              <Button
                       backgroundColor="#3D5A80"
                       border= "1px solid #D9D9D9"
                       borderRadius="76px"
                       p="9px 18px"
                       fontSize="12px"
                       fontWeight={500}
                       lineHeight="14.4px"
                       color="#FFFFFF"
                       _hover={{
                        backgroundColor:"#3D5A80"
                      }}
                      onClick={()=>handleBlockUser()}
              >
                {t('profileNetwork.block') || "Block"}
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default UserBlockPopup;
